<script setup lang="ts"></script>

<template>
  <h3 class="card-title mb-3 text-primary-emphasis d-flex align-items-center justify-content-between">
    <span>
      <slot />
    </span>
    <div class="d-flex align-items-center">
      <slot name="actions" />
    </div>
  </h3>
</template>

<style scoped>
.card-title,
.card-title ::v-deep(h3 span) {
  font-size: 22px;
  font-weight: 600;
}
</style>
